import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home =() => import('views/home/home')
const Detail = () => import('views/detail/detail')
const Pagedetail =() => import('views/pagedetail/pagedetail')
const Login = () => import('views/login/login')
const User = () => import('views/userinfo/user')
const sele = () => import('../components/editor/editor.vue')

const division = () => import('views/userinfo/child/division')
const division2 = () => import('views/userinfo/child/division2')
const routes = [
	{
	    path: '',
	    redirect: '/home',
	},
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
	{
	  path:'/home/:id',
	  name: 'Detail',
	  component: Detail
	},
	{
	  path:'/home/:id/:index',
	  name: 'Pagedetail',
	  component: Pagedetail
	},
	{
	  path:'/login',
	  name: 'Login',
	  component: Login
	},
	{
	  path:'/User',
		redirect: '/User/create',
	  component: User,
		children:[
			{
				path:'create',
				component:division
			},
			{
				path:'sele',
				component:division2
			}
		]
	},
	{
	  path:'/sele',
	  name: 'sele',
	  component: sele
	},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
